module.exports = __webpack_public_path__ + "static/media/forstyrre.5a804b68.m4a";